import SettingsAppConfig from './urbanhive-settings/SettingsAppConfig';
import CandidateAppConfig from './urbanhive-candidates/CandidateAppConfig';
import ComingSoonPageConfig from './urbanhive-coming-soon/ComingSoonPageConfig';
import Error404PageConfig from './urbanhive-errors/404/Error404PageConfig';
import Error500PageConfig from './urbanhive-errors/500/Error500PageConfig';
import InboxAppConfig from './urbanhive-inbox/InboxAppConfig';
import ProspectsConfig from './urbanhive-prospects/ProspectsConfig';
import InboxEventsAppConfig from './urbanhive-inbox-events/InboxEventsAppConfig';
import ProfileConfig from './urbanhive-profile/ProfileConfig';
import LoginConfig from './urbanhive-login/LoginConfig';
import RegisterConfig from './urbanhive-register/RegisterConfig';
import SessionsConfig from './urbanhive-sessions/SessionsConfig';
import BookDevConfig from './urbanhive-bookdev/BookDevConfig';
import RegisteredUsersConfig from './urbanhive-admin-registered-users/RegisteredUsersConfig';
import AssignedBookingsConfig from './urbanhive-admin-assigned-bookings/AssignedBookingsConfig';
import DeveloperListConfig from './urbanhive-admin-developer-list/DeveloperListConfig';
import CreateNewDeveloperConfig from './urbanhive-admin-create-developer/CreateNewDeveloperConfig';
import EditAppointmentConfig from './urbanhive-admin-edit-appointment/EditAppointmentConfig';
import BootCampConfig from './urbanhive-bootcamp/BootcampConfig';
import BootCampDetailsConfig from './urbanhive-bootcamp-details/BootCampDetailsConfig';
import DashboardAppConfig from './urbanhive-dashboard/DashboardAppConfig';
import ProfileUpdateConfig from './urbanhive-profile-update/ProfileUpdateConfig';
import CardsAppConfig from './urbanhive-cards/CardsAppConfig';
import NewsletterAppConfig from './urbanhive-newsletter/NewsletterAppConfig';
import BirthdayOneAppConfig from './urbanhive-birthday-1/BirthdayAppConfig';
import BirthdayTwoAppConfig from './urbanhive-birthday-two/BirthdayAppConfig';
import HolidayOneAppConfig from './urbanhive-holiday-one/HolidayAppConfig';
import ForgotPasswordConfig from './urbanhive-forgot-password/ForgotPasswordConfig';
import EventsAppConfig from './urbanhive-events/EventsAppConfig';
import InteractionPageConfig from './urbanhive-interactions/InteractionsPageConfig';
import MessageViewPageConfig from './urbanhive-message-view/MessageViewPageConfig';
import ContactUsPageConfig from './urbanhive-contact-us-page/ContactUsPageConfig';

const appsConfigs = [
  LoginConfig,
  ProspectsConfig,
  ForgotPasswordConfig,
  RegisterConfig,
  CandidateAppConfig,
  InboxAppConfig,
  InboxEventsAppConfig,
  ProfileConfig,
  ProfileUpdateConfig,
  DashboardAppConfig,
  BirthdayOneAppConfig,
  BirthdayTwoAppConfig,
  HolidayOneAppConfig,
  CardsAppConfig,
  NewsletterAppConfig,
  ComingSoonPageConfig,
  Error404PageConfig,
  Error500PageConfig,
  SessionsConfig,
  BookDevConfig,
  RegisteredUsersConfig,
  AssignedBookingsConfig,
  DeveloperListConfig,
  CreateNewDeveloperConfig,
  EditAppointmentConfig,
  BootCampConfig,
  BootCampDetailsConfig,
  SettingsAppConfig,
  EventsAppConfig,
  InteractionPageConfig,
  MessageViewPageConfig,
  ContactUsPageConfig,
];

export default appsConfigs;
